import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

const solutionData = {
  id: 'geodetic-survey',
  name: 'Geodetic Survey',
  icon: <GpsFixedIcon sx={{ fontSize: 60 }} />,
  description: 'High-accuracy position determination and reference point surveys',
  overview: `Geodetic surveys involve the high accuracy position determination surveys to enable the use of the positions in other survey and positioning works as reference point. This usually involves accurate determination of position on the X, Y & Z planes based on a specific projection system and reference frame. Geodesist are able to re-project coordinates from one system to another. Reference points adopted are mainly the Survey of Kenya reference points if for example the survey is in Kenya or use any available CORS station. Higher order trigonometric stations are preferred. We conduct our geodetic surveys using modern GNSS geodetic grade receivers that are able to determine longitude, latitude and ellipsoidal heights in a geographic system or Northing, Easting and Ellipsoidal height in a rectilinear system.`,
  features: [
    {
      title: 'High Accuracy Positioning',
      description: 'Precise determination of X, Y & Z coordinates',
    },
    {
      title: 'Modern GNSS Technology',
      description: 'Geodetic grade receivers for accurate measurements',
    },
    {
      title: 'Coordinate System Flexibility',
      description: 'Ability to work with multiple projection systems',
    },
    {
      title: 'Reference Point Integration',
      description: 'Use of established survey reference points and CORS stations',
    },
    {
      title: 'Multiple Output Formats',
      description: 'Geographic and rectilinear coordinate system support',
    },
  ],
  benefits: [
    'High precision measurements',
    'Multiple coordinate system support',
    'Reference point establishment',
    'Modern equipment utilization',
    'Professional survey standards',
  ],
};

const GeodeticSurvey = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default GeodeticSurvey; 